import * as types from "../types";

const state = {
  wallets: null,
  walletsSetting: {
    nameType: "name_locale",
    assetsType: "IRR",
    assetsTypeCurrency: {}
  },
  newWallets: [],
  checkWallets: [],
  exchangeWallets: [],
  marketConditionsWallets: null,
  openModalMarketConditionsWallets: null
};

const getters = {
  [types.wallets.getters.GET_WALLETS]: state => {
    return state.wallets;
  },
  [types.wallets.getters.GET_WALLETS_SETTING]: state => {
    return state.walletsSetting;
  },
  [types.wallets.getters.GET_NEW_WALLETS]: state => {
    return state.newWallets;
  },
  [types.wallets.getters.GET_CHECK_WALLETS]: state => {
    return state.checkWallets;
  },
  [types.wallets.getters.GET_EXCHANGE_WALLETS]: state => {
    return state.exchangeWallets;
  },
  [types.wallets.getters.GET_MARKET_CONDITIONS_WALLETS]: state => {
    return state.marketConditionsWallets;
  },
  [types.wallets.getters.GET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS]: state => {
    return state.openModalMarketConditionsWallets;
  }
};

const mutations = {
  [types.wallets.mutations.MUTATE_WALLETS]: (state, payload) => {
    state.wallets = payload;
  },
  [types.wallets.mutations.MUTATE_WALLETS_SETTING]: (state, payload) => {
    state.walletsSetting[payload.key] = payload.value;
    state.walletsSetting.assetsTypeCurrency = payload.currency;
  },
  [types.wallets.mutations.MUTATE_EXCHANGE_WALLETS]: (state, payload) => {
    state.exchangeWallets = payload;
  },
  [types.wallets.mutations.MUTATE_NEW_WALLETS]: (state, payload) => {
    if (state.newWallets.length !== 0) {
      state.newWallets = [];
      state.newWallets = payload;
    } else {
      state.newWallets = payload;
    }
  },
  [types.wallets.mutations.MUTATE_CHECK_WALLETS]: (state, payload) => {
    if (state.newWallets.length !== 0) {
      state.checkWallets = [];
      state.checkWallets = payload;
    } else {
      state.checkWallets = payload;
    }
  },
  [types.wallets.mutations.UPDATE_CHECK_WALLETS]: (state, payload) => {
    state.checkWallets.find(elem => {
      if (elem.id === payload.id) {
        elem.show_update = payload.show_update;
      }
    });
  },
  [types.wallets.mutations.MUTATE_MARKET_CONDITIONS_WALLETS]: (
    state,
    payload
  ) => {
    state.marketConditionsWallets = payload;
  },
  [types.wallets.mutations.MUTATE_OPEN_MODAL_MARKET_CONDITIONS_WALLETS]: (
    state,
    payload
  ) => {
    state.openModalMarketConditionsWallets = payload;
  }
};

const actions = {
  [types.wallets.actions.SET_WALLETS]: ({ commit }, payload) => {
    commit(types.wallets.mutations.MUTATE_WALLETS, payload);
  },
  [types.wallets.actions.SET_WALLETS_SETTING]: ({ commit }, payload) => {
    commit(types.wallets.mutations.MUTATE_WALLETS_SETTING, payload);
  },
  [types.wallets.actions.SET_NEW_WALLETS]: ({ commit }, payload) => {
    commit(types.wallets.mutations.MUTATE_NEW_WALLETS, payload);
  },
  [types.wallets.actions.SET_EXCHANGES_WALLETS]: ({ commit }, payload) => {
    commit(types.wallets.mutations.MUTATE_EXCHANGE_WALLETS, payload);
  },
  [types.wallets.actions.SET_CHECK_WALLETS]: ({ commit }, payload) => {
    commit(types.wallets.mutations.MUTATE_CHECK_WALLETS, payload);
  },
  [types.wallets.actions.UPDATE_CHECK_WALLETS]: ({ commit }, payload) => {
    commit(types.wallets.mutations.UPDATE_CHECK_WALLETS, payload);
  },
  [types.wallets.actions.SET_MARKET_CONDITIONS_WALLETS]: (
    { commit },
    payload
  ) => {
    commit(types.wallets.mutations.MUTATE_MARKET_CONDITIONS_WALLETS, payload);
  },
  [types.wallets.actions.SET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS]: (
    { commit },
    payload
  ) => {
    commit(
      types.wallets.mutations.MUTATE_OPEN_MODAL_MARKET_CONDITIONS_WALLETS,
      payload
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
